import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    retrieved: {
      translations: [],
      files: []
    }
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/category/show/index.js